import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import {
  AssignmentCategory,
  StudentProgressBook,
} from '../../../../constants/types/lms/student/homework/type';
import TextWinds from '../../../common/TextWinds';
import BookSubjectProgressRow from './BookSubjectProgressRow';

interface BookProgressCardProps {
  selectedCategory: AssignmentCategory;
  book: StudentProgressBook;
  isOpened: boolean;
  onOpenToggle: () => void;
}

/**
 * 개편 LMS (학생) - 클래스 상세 페이지 > 콘텐츠 판넬 > 우측 젭스온(AI인증제 제외), WMW, HFHJ [진도 지도] > Book 카드
 */
const BookProgressCard = ({
  selectedCategory,
  book,
  isOpened,
  onOpenToggle,
}: BookProgressCardProps) => {
  return (
    <article className="overflow-hidden rounded-xl border border-gray3 bg-white shadow-sm">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left"
        onClick={onOpenToggle}
      >
        <div className="flex min-w-0 items-center gap-4">
          <TextWinds
            type="content_body2"
            color="gray8"
            className="w-[90px] shrink-0 font-bold"
          >
            {book.book}
          </TextWinds>
        </div>

        <div className="flex shrink-0 items-center gap-3">
          {isOpened ? (
            <ChevronUpIcon className="h-5 w-5 text-gray6" />
          ) : (
            <ChevronDownIcon className="h-5 w-5 text-gray6" />
          )}
        </div>
      </button>

      {isOpened && (
        <div className="border-t border-gray3 px-4 py-4">
          <div className="flex flex-col gap-3">
            {book.subjects.map((subject) => (
              <BookSubjectProgressRow
                key={`${book.book}-${subject.subjectCode}`}
                selectedCategory={selectedCategory}
                subject={subject}
              />
            ))}
          </div>
        </div>
      )}
    </article>
  );
};

export default BookProgressCard;
